// Important: this needs to be updated if form fields get added/moved to different sections
export const getErroredAccordionIndexes = ({ errors }) => {
  // each index corresponds to a section in the accordion
  const accordionSectionFields = [
    [
      'linkType',
      'name',
      'icon',
      'description',
      'personalisationTags',
      'links',
      'imageUrl',
      'displayLabel',
      'relevance',
    ],
    ['categories'],
    ['filters'],
    ['tags', 'longDescription'],
  ];

  const erroredIndexes = [];

  accordionSectionFields.forEach((section, i) => {
    if (section.some((fieldName) => fieldName in errors)) {
      erroredIndexes.push(i);
    }
  });

  return erroredIndexes;
};
